// extracted by mini-css-extract-plugin
module.exports = {"home_intro":"wHZ7qg","description":"DfUEA4"};